import { headlinks } from '../utilities/links'
import socialIcons from './Icons/SocialIcons'
import CustomLink from './Widgets/ScrollLink';
import smartaLogo from "../assets/smarta.png"

const Footer = () => {
	return (
		<footer className="app-x py-10 bg-slate-900 flex justify-between space-y-4 lg:space-y-0 flex-wrap overflowed">
			<h3 className='font-bold flex h-fit space-x-2 items-center text-white font-serif w-full lg:w-fit text-xl mb-3'>
				<img src={smartaLogo} className="w-8 rm-drag" alt="logo" />
				<span>SMARTA</span>
			</h3>
			<div>
				<h2 className='text-slate-200 font-serif font-bold mb-4'>Quick Links</h2>
				<ul className='grid grid-cols-3 gap-y-4 gap-x-5'>
					{[
						...headlinks,
						{ text: "Coaching", to: "coaching", scrollOn: "/" },
						{ text: "Topics", to: "topicsCovered", scrollOn: "/" },
					].map(({ text, to, scrollOn }, i) => (
						<li key={i} >
							<CustomLink to={to} scrollOn={scrollOn}>
								<button className='text-slate-400 text-left focused rounded transition duration-300 hover:text-slate-300 text-[.8rem]'>
									{text}
								</button>
							</CustomLink>
						</li>
					))}
				</ul>
			</div>
			<div>
				<h2 className='text-slate-200 font-serif font-bold mb-4'>Contact</h2>
				<div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
					{socialIcons.map(({ icon, text, link }, i) => (
						<a key={i} href={link} target="_blank" rel='noreferrer' className='text-slate-400 focused rounded transition duration-300 hover:text-slate-300 flex space-x-2 text-[.8rem]'>
							<span>{icon}</span>
							<span>{text}</span>
						</a>
					))}
				</div>
			</div>
			<div className='text-slate-300 text-xs w-full text-center pt-10'>SMARTA &copy; 2023</div>
		</footer>
	)
}

export default Footer